/**
 * @function isPositive
 * @param {number} value
 * @return {boolean} if value > 0
 */
export const isPositive = function isPositive(value: number): boolean {
  return value > 0;
};

/**
 * @function isZero
 * @param {number} value
 * @return {boolean} if value === 0
 */
export const isZero = function isZero(value: number): boolean {
  return value === 0;
};

/**
 * @function roundToNearestEvenNumber
 * @param {number} number to round
 * @return {number} number rounded to nearest even number
 */
export function roundToNearestEvenNumber(int: number): number {
  return 2 * Math.round(int / 2);
}

/**
 * @function formatNumber
 * @param {number} value
 * @return {string} number with digits grouping separators
 */
export function formatNumber(value: number): string {
  return value.toLocaleString();
}
